import React from 'react';
import '../../App.css';
import QuotationMasterForm from '../QuotationMaster';

function QuotationMaster({ sessionObject }) {
  if(!sessionObject.sessionVariables["modules"].includes("quotation")){
    return;}
  return (
    <div className="page-mr">
      <QuotationMasterForm sessionObject={sessionObject}/>
    </div>
  );
}

export default QuotationMaster;
